import React from "react";
import RegistrationPage from "../RegistrationPage/RegistrationPage";
import LoginPage from "../LoginPage/LoginPage";
import "./AuthPage.css";
import Footer from "../Footer/Footer";
// import bgImage from "../../assets/images/brown-background.jpg";
import bgImage from "../../assets/images/brown-background.jpg";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from 'react-icons/fa';
const AuthPage = () => {
  return (
    <div className="mainallsection">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Login</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Login
        </p>
      </div>
      <div
        className="auth-container"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="containerall">
          <div className="auth-box">
            <div className="login-section">
              <LoginPage />
            </div>

            <div className="registration-section">
              <RegistrationPage />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
